export const latest_editor_version = '1.1.3';
export const editor_versions_list = ['1.1.3', '1.1.2'];
